import React, { useState } from 'react';
import { Form, Button } from 'antd';
import { useTranslation } from 'react-i18next';
import { useDispatch } from 'react-redux';
import PropTypes from 'prop-types';
import { authUser } from '../../reducer/actions';
import { EyeInvisibleOutlined } from '@ant-design/icons';
import { ReactComponent as Open } from '../../../../images/eyes_open.svg';
import InputPassword from './InputPassword';
import InputEmail from './InputEmail';

function AuthForm({ setForgot }) {
  const [loading, setLoading] = useState(false);
  const [falseData, setFalseData] = useState(false);
  const { t } = useTranslation();
  const dispatch = useDispatch();
  const handleSubmit = (value) => {
    setLoading(true);
    dispatch(authUser(value, setLoading, setFalseData));
  };
  return (
    <div className="w-422 flex items-center justify-center flex-col">
      <h1 className="text-36 font-bold">{t('auth')}</h1>
      <div className="p-0 w-285 text-center m-center mb-20 ">
        {t('subAuth')}
      </div>

      <div className="bg-white border-lightGray  rounded-lg w-full p-30 text-center">
        <Form
          name="basic"
          initialValues={{
            remember: true,
          }}
          onFinish={handleSubmit}
        >
          <Form.Item
            name="username"
            rules={[
              {
                required: true,
                message: 'Please input your e-mail!',
              },
            ]}
          >
            <InputEmail
              className="border-t-none border-r-none border-l-none border-b border-lightGray pb-10 rounded-none active:border-t-none shadow-none"
              placeholder={t('inputYourEmail')}
            />
          </Form.Item>
          <Form.Item
            name="password"
            rules={[
              {
                required: true,
                message: 'Please input your password!',
              },
            ]}
          >
            <InputPassword
              iconRender={(visible) =>
                visible ? <Open /> : <EyeInvisibleOutlined />
              }
              className="border-t-none border-r-none border-l-none border-b border-lightGray pb-10 rounded-none"
              placeholder={t('inputYourPass')}
            />
          </Form.Item>
          <Form.Item>
            <Button
              loading={loading}
              className="w-full"
              type="primary"
              htmlType="submit"
            >
              {t('logIn')}
            </Button>
          </Form.Item>
        </Form>
        {falseData && <div className="text-red">
          {t('dataNotFind')}
        </div>}
        <Button
          onClick={() => {
            setForgot(true);
          }}
          className="forgot"
          type="link"
        >
          <span className="border-b border-dotted border-linkLine">
            {t('forgotPass')}
          </span>
        </Button>
      </div>

    </div>
  );
}

AuthForm.propTypes = {};

export default AuthForm;
